import { Component, Input } from "@angular/core";

export interface Breadcrumb {
  label: string;
  route: string;
  queryParams?: {};
}

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs!: Breadcrumb[];

  trackByFn(index: number, item: any): any {
    return item.id; // or any unique property
  }
}
